import { extendTheme } from '@chakra-ui/react';

const theme = {
    baseStyle: {
        //fontSize: 'sm',
        marginBottom: '1'
    },
    defaultProps: {
        size: 'sm',
    }
};

export default theme